module.exports = __webpack_public_path__ + "84370fd4723006ab7a769e77044c267a.pdf";